
export default function WhySonomaRoutes() {
  const benefits = [
    {
      icon: 'ri-box-3-line',
      title: 'Small Initial Placements',
      description: 'Test products with minimal risk. We start small and scale based on actual sales performance, not guesswork.'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Inventory Rotation',
      description: 'Fresh products, always. We manage expiration dates and ensure your shelves stay current and compliant.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Tight Geographic Routes',
      description: 'Focused on Sonoma County. Efficient routes mean lower costs, faster response times, and better service.'
    },
    {
      icon: 'ri-bar-chart-line',
      title: 'Data-Driven Reordering',
      description: 'We track what sells and reorder accordingly. No overstocking, no stockouts—just smart inventory management.'
    }
  ];

  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Sonoma Routes
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            A disciplined approach to local distribution
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {benefits.map((benefit, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-gray-900 rounded-lg flex items-center justify-center mx-auto mb-6">
                <i className={`${benefit.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {benefit.title}
              </h3>
              <p className="text-sm text-gray-700 leading-relaxed">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
